import moment from 'moment'

export const toThaiDatetime = (date, format = 'D MMMM Y') => {
  const m = moment(date)

  if (!m.isValid()) return null

  const thaiYear = m.year() + 543

  format = format.replace(/Y+/g, thaiYear)

  return m.format(format)
}
